import { webClient, webClientConfig } from "@shared/apis"
import { Viewer } from "@shared/contexts"

export default {
  status: () =>
    webClient.get<Viewer>(`/viewers/status`, {
      params: { scheduleId: webClientConfig.scheduleId },
    }),
  kick: (scheduleId: string | number | undefined, username: string) =>
    webClient.delete(`/viewers/kick`, {
      params: { scheduleId, username },
    }),
  blockingChat: (scheduleId: string | number | undefined, username: string) =>
    webClient.delete(`/viewers/blocking_chat`, {
      params: { scheduleId, username },
    }),
  unBlockingChat: (scheduleId: string | number | undefined, username: string) =>
    webClient.put(`/viewers/unblocking_chat`, { scheduleId, username }),
}
